import { useEffect, useState } from 'react';
import api from '../../axios/axios'
import Swal from 'sweetalert2';
import { useDispatch, useSelector } from 'react-redux';
import { setSelectedAddress } from '../../redux/features/auth/userSlice';
// import Spinner from '../../utils/Spinner';
import InputMask from "react-input-mask";

const AddressForm = ({fetchCheckOutPage,loading}) => {
  // State to manage form visibility
  const [isFormVisible, setIsFormVisible] = useState(false);
  const checkOutDetails=useSelector((state)=>state.user.checkoutDetails)
const addresses = checkOutDetails?.addresses || [];
const userInfo=checkOutDetails?.userInfo
const userName=userInfo?.fullName
const email=userInfo?.email
  const [formData, setFormData] = useState({
    fullName: userName || '', // Initialize with userInfo value or empty string
    email: email || '', // Initialize with userInfo value or empty string
    phoneNumber:0,
    address: '',
    city: '',
    province: '',
    zipCode:''
  
  });
  
const currentUser=useSelector((state)=>state.user.currentUser)
const dispatch=useDispatch()

useEffect(() => {
  // Cleanup function to reset form data
  return () => {
    setFormData({
      fullName: userInfo?.fullName,
      email:userInfo?.email,
      phoneNumber: '',
      address: '',
      city: '', 
      province: '',
      zipCode: ''
    });
  };
}, [isFormVisible]);


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value, // Use [name] to dynamically set the property in formData
    }));
  };
//   if(loading){
//     return(<>
//     <Spinner/>
//     </>)
//   }

const handleSubmit = async (e) => {
  e.preventDefault();

  // Show confirmation dialog before proceeding with the submission
  const result = await Swal.fire({
    title: 'Are you sure?',
    text: 'Do you want to submit the form with the provided details?',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Yes, submit it!',
    cancelButtonText: 'No, cancel',
  });

  // If the user clicks "Yes, submit it!", proceed with the form submission
  if (result.isConfirmed) {
    const formDataToSend = new FormData();
    formDataToSend.append('fullName',formData.fullName)
    formDataToSend.append('address', formData.address);
    formDataToSend.append('city', formData.city);
    formDataToSend.append('province', formData.province);
    formDataToSend.append('zipCode', formData.zipCode);  // Make sure this matches your form data state key
    formDataToSend.append('phoneNumber',formData.phoneNumber)
    formDataToSend.append('userId', currentUser._id);

    try {
      // Send the form data
      const response = await api.post('user/submitAddress', formDataToSend);
      // Show success alert
      Swal.fire({
        icon: 'success',
        title: 'Success!',
        text: 'Your form has been submitted successfully.',
        confirmButtonText: 'OK', 
      });
      setIsFormVisible(!isFormVisible)
      fetchCheckOutPage()
      setFormData({
      fullName:'',
      email:'',
        address:'',
        city:'',
        province:'',
        zipCode:'',
      })
    } catch (error) {
      console.log('er',error)
      // Show error alert if something goes wrong
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Something went wrong. Please try again.',
        confirmButtonText: 'OK',
      });
    }
  } else {
    // If the user clicks "Cancel", do nothing
    Swal.fire("Form Submission cancelled");
  }
};

function handleAddressChange(event) {
  const selectedAddressId = event.target.value; // Get the selected address ID
  const selectedAddress = checkOutDetails.addresses.find(
    (address) => address._id === selectedAddressId
  );
  dispatch(setSelectedAddress(selectedAddress))
}
// if(!userInfo){
//   return(
//     <>
//     <Spinner/>
//     </>
//   )
// }


  return (
    <div className="bg-gray-900 p-8 rounded-xl shadow-xl max-w-4xl mx-auto">
      <h2 className="text-3xl font-bold text-white mb-6">Shipping Information</h2>

      {/* Dropdown to select saved addresses */}
      {/* Dropdown to select saved addresses */}
{/* Dropdown to select saved addresses */}
<div className="mt-6">
  <label className="block text-gray-300 mb-2">Select Saved Address</label>
  {addresses.length > 0 ? (
    <select
    onChange={handleAddressChange}

    className="w-full p-4 bg-white border border-gray-300 rounded-lg shadow-md focus:ring-2 focus:ring-indigo-500 focus:outline-none">
      <option value="" disabled selected>
        Choose an address
      </option>
      {checkOutDetails?.addresses?.map((addressObj, index) => (
  <option key={index} value={addressObj._id}>
    {`${addressObj.address}, ${addressObj.city}, ${addressObj?.province} - ${addressObj.zipCode}`}
  </option>
))}

    </select>
  ) : (
    <div className="flex items-center justify-center p-4 bg-gray-800 rounded-lg shadow-md">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={2}
        stroke="currentColor"
        className="w-6 h-6 text-indigo-500 mr-2"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M9.75 9h.008v.008H9.75V9zM14.25 9h.008v.008h-.008V9zM12 15.75a.75.75 0 10-1.5 0 .75.75 0 001.5 0z"
        />
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M21 12c0 4.97-4.03 9-9 9s-9-4.03-9-9 4.03-9 9-9 9 4.03 9 9z"
        />
      </svg>
      <p className="text-gray-300 font-semibold text-lg">No addresses found.</p>
    </div>
  )}
</div>



      {/* Button to toggle the form visibility */}
      <button
        onClick={() => setIsFormVisible(!isFormVisible)}
        className="w-full py-3 px-4 bg-indigo-600 text-white font-semibold rounded-lg shadow-md hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 mb-6 mt-6"
      >
        {isFormVisible ? 'Cancel Address Form' : 'Add New Address'}
      </button>

      {/* Conditionally render the form */}
      {isFormVisible && (
       <form onSubmit={handleSubmit} className="space-y-6">
       <div className="flex gap-4">
         <div className="w-1/2">
           <label className="block text-gray-300 mb-2">Full Name</label>
           <input
    value={formData.fullName} // Use formData here
    onChange={handleChange}
             type="text"
             name="fullName"
             className="w-full p-4 bg-white border border-gray-300 rounded-lg shadow-md focus:ring-2 focus:ring-indigo-500 focus:outline-none"
             placeholder="John Doe"
             required
           />
         </div>
         <div className="w-1/2">
           <label className="block text-gray-300 mb-2">Email</label>
           <input
    value={formData.email} // Use formData here 
             onChange={handleChange}
             type="email"
             name="email"
             className="w-full p-4 bg-white border border-gray-300 rounded-lg shadow-md focus:ring-2 focus:ring-indigo-500 focus:outline-none"
             placeholder="email@example.com"
             required
           />
         </div>
       </div>
       <div>
         <label className="block text-gray-300 mb-2">Address</label>
         <input
           onChange={handleChange}
           type="text"
           name="address"
           className="w-full p-4 bg-white border border-gray-300 rounded-lg shadow-md focus:ring-2 focus:ring-indigo-500 focus:outline-none"
           placeholder="1234 Main St"
           required
         />
       </div>
       <div className='flex gap-4'>
       <div className='w-1/2'>
         <label className="block text-gray-300 mb-2">City</label>
         <input
           onChange={handleChange}
           type="text"
           name="city"
           className="w-full p-4 bg-white border border-gray-300 rounded-lg shadow-md focus:ring-2 focus:ring-indigo-500 focus:outline-none"
           placeholder="City"
           required
         />
       </div>
       <div className="w-full md:w-1/2">
  <label className="block text-gray-300 mb-2">
    Phone Number
  </label>
  <InputMask
    mask="(999) 999-9999"
    onChange={handleChange}
    name="phoneNumber"
    className="w-full p-4 bg-white border border-gray-300 rounded-lg shadow-md focus:ring-2 focus:ring-indigo-500 focus:outline-none"
    placeholder="(XXX) XXX-XXXX"
    required
  />
 
</div>


       </div>
       <div className="flex gap-4">
         <div className="w-1/2">
           <label className="block text-gray-300 mb-2">Province</label>
           <select
             onChange={handleChange}
             name="province"
             className="w-full p-4 bg-white border border-gray-300 rounded-lg shadow-md focus:ring-2 focus:ring-indigo-500 focus:outline-none"
             required
           >
             <option value="">Select Province</option>
             <option value="AB">Alberta</option>
             <option value="BC">British Columbia</option>
             <option value="MB">Manitoba</option>
             <option value="NB">New Brunswick</option>
             <option value="NL">Newfoundland and Labrador</option>
             <option value="NS">Nova Scotia</option>
             <option value="ON">Ontario</option>
             <option value="PE">Prince Edward Island</option>
             <option value="QC">Quebec</option>
             <option value="SK">Saskatchewan</option>
             <option value="NT">Northwest Territories</option>
             <option value="NU">Nunavut</option>
             <option value="YT">Yukon</option>
           </select>
         </div>
         <div className="w-1/2">
           <label className="block text-gray-300 mb-2">Zip Code</label>
           <input
             name="zipCode"
             onChange={handleChange}
             type="text"
             className="w-full p-4 bg-white border border-gray-300 rounded-lg shadow-md focus:ring-2 focus:ring-indigo-500 focus:outline-none"
             placeholder="10001"
             required
           />
         </div>
       </div>
       <div>
         <button
           type="submit"
           className="w-full py-3 px-4 bg-indigo-600 text-white font-semibold rounded-lg shadow-md hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500"
         >
           Submit
         </button>
       </div>
     </form>
     
      )}
    </div>
  );
};

export default AddressForm;